import styled from 'styled-components';
import { palette } from 'styled-tools';

import { minWidth } from '@calm-web/design-system';

export const IconBubble = styled.div<{ $icon: 'mind' | 'relax' | 'sleep' }>`
	border-radius: 100px;
	width: 80px;
	height: 80px;
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 0 auto 14px auto;
	background: ${p => {
		switch (p.$icon) {
			case 'mind':
				return palette('gradientRainbow4')(p);
			case 'relax':
				return palette('gradientRainbow5')(p);
			case 'sleep':
				return palette('gradientSleepLight')(p);
		}
	}};
	& svg {
		width: 48px;
		height: 100%;
	}
	& path {
		fill: white;
	}

	${minWidth('tablet')} {
		margin: 0;
	}
`;

export const Section = styled.section`
	background-color: ${palette('gray0')};
	width: 100%;
`;
export const GridWrapper = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	justify-items: center;
	padding: 30px;
	max-width: 1318px;
	margin: auto;
	${minWidth('tablet')} {
		padding: 75px;
		grid-template-columns: repeat(3, auto);
		justify-content: space-between;
		column-gap: 1rem;
	}
`;

export const Column = styled.div`
	text-align: center;
	max-width: 300px;
	justify-content: center;
	margin-bottom: 16px;

	&:last-child {
		margin-bottom: 0;
	}

	${minWidth('tablet')} {
		margin: 0;
		justify-content: start;
		text-align: left;
	}
`;
